import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useReducer, useCallback } from 'react';
import { createAccountService } from '@restworld/data-services';
import { isValidToken, setSession } from '../utils';
import { initialState, jwtTokenLocalStorage, Types } from '../constants';
import { JWTReducer } from '../reducer';
export var useAuthFunctions = function useAuthFunctions(baseUrl) {
  var _useReducer = useReducer(JWTReducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1]; // initialize method


  var initialize = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(jwtArgs) {
      var jwt, clearSession, _yield$createAccountS, user;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              jwt = jwtArgs || jwtTokenLocalStorage;

              clearSession = function clearSession() {
                setSession(null);
                dispatch({
                  type: Types.Initial,
                  payload: {
                    isAuthenticated: false,
                    user: null
                  }
                });
              };

              if (!(jwt && isValidToken(jwt))) {
                _context.next = 26;
                break;
              }

              _context.prev = 3;
              _context.next = 6;
              return createAccountService({
                jwt: jwt,
                baseUrl: baseUrl
              }).me();

            case 6:
              _context.t1 = _yield$createAccountS = _context.sent.data;
              _context.t0 = _context.t1 === null;

              if (_context.t0) {
                _context.next = 10;
                break;
              }

              _context.t0 = _yield$createAccountS === void 0;

            case 10:
              if (!_context.t0) {
                _context.next = 14;
                break;
              }

              _context.t2 = void 0;
              _context.next = 15;
              break;

            case 14:
              _context.t2 = _yield$createAccountS.data;

            case 15:
              user = _context.t2;
              setSession(jwt);
              dispatch({
                type: Types.Initial,
                payload: {
                  isAuthenticated: true,
                  user: user,
                  jwt: jwt
                }
              });
              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t3 = _context["catch"](3);
              console.error('Error during authentication initialization:', _context.t3);
              clearSession();

            case 24:
              _context.next = 27;
              break;

            case 26:
              clearSession();

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 20]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [baseUrl]); //login method

  var login = useCallback(function (email, password) {
    return createAccountService({
      baseUrl: baseUrl
    }).login({
      email: email,
      password: password
    }).then( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(res) {
        var jwt;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                jwt = res.data.jwt;
                setSession(jwt);
                initialize(jwt);
                return _context2.abrupt("return", res.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }())["catch"](function (e) {
      return e;
    });
  }, [baseUrl, initialize]); //register method

  var signUp = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, email, password) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return createAccountService({
                baseUrl: baseUrl
              }).signUp({
                id: id,
                email: email,
                password: password
              }).then(function (res) {
                var jwt = res.data.jwt;
                var user = res.data;
                setSession(jwt);
                dispatch({
                  type: Types.Register,
                  payload: {
                    isAuthenticated: true,
                    user: user,
                    jwt: jwt
                  }
                });
                return res;
              })["catch"](function (error) {
                dispatch({
                  type: Types.Register,
                  payload: {
                    isAuthenticated: false,
                    user: null,
                    error: error
                  }
                });
                return error;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }(), [baseUrl]); //logout method

  var logout = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return createAccountService({
              baseUrl: baseUrl
            }).logout().then(function () {
              setSession(null);
              dispatch({
                type: Types.Logout,
                payload: {
                  isAuthenticated: false,
                  user: null,
                  isReady: true,
                  jwt: null,
                  logoutRedirect: true
                }
              });
            })["catch"](function (error) {
              dispatch({
                type: Types.Logout,
                payload: {
                  isAuthenticated: false,
                  user: null,
                  error: error
                }
              });
              return error;
            });

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [baseUrl]); // reset password method

  var resetPassword = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, newPassword, jwt) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return createAccountService({
                baseUrl: baseUrl
              }).resetPassword({
                id: id,
                newPassword: newPassword,
                jwt: jwt
              }).then(function (res) {
                var user = res.data;
                var accessToken = res.data.jwt;
                setSession(accessToken);
                dispatch({
                  type: Types.Login,
                  payload: {
                    isAuthenticated: true,
                    isReady: true,
                    user: user,
                    jwt: accessToken
                  }
                });
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x6, _x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }(), [baseUrl]); //Verify Token

  var verifyToken = useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(token) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return createAccountService({
                baseUrl: baseUrl,
                jwt: token
              }).me().then(function (response) {
                var user = response.data.data;
                setSession(token);
                dispatch({
                  type: Types.VerifyToken,
                  payload: {
                    isAuthenticated: true,
                    user: user,
                    jwt: token,
                    isReady: true,
                    loginRedirect: false
                  }
                });
              })["catch"](function (error) {
                setSession(null);
                dispatch({
                  type: Types.VerifyToken,
                  payload: {
                    isAuthenticated: false,
                    user: null,
                    error: error,
                    isReady: true,
                    loginRedirect: true
                  }
                });
              });

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x9) {
      return _ref6.apply(this, arguments);
    };
  }(), [baseUrl]);

  var invalidateSession = function invalidateSession() {
    setSession(null);
    dispatch({
      type: Types.Logout,
      payload: {
        isAuthenticated: false,
        user: null,
        isReady: true,
        jwt: null,
        logoutRedirect: true
      }
    });
  };

  return {
    state: state,
    login: login,
    logout: logout,
    signUp: signUp,
    resetPassword: resetPassword,
    initializeAuthentication: initialize,
    verifyToken: verifyToken,
    invalidateSession: invalidateSession,
    initialize: initialize
  };
};